// 관리자 로그인 토큰 저장 키 (AdminLogin / AdminDashboard 공용)
export const ADMIN_TOKEN_KEY = 'admin_token';

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY) || '';

export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);
